import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import QRCodeForm from './QRCodeForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewQRCodeModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }

    submitHandler = ( qrCode ) => {
        this.setState( { fetching: true } );
        this.props.createQRCode( qrCode )
        .then( ( newQRCode ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newQRCode );
        } );
    }

    render() {
        const initialValues = { };
        return (
            <DLModal title='New QR Code'
            closeHandler={ this.props.closeModal }>
                <div>
                    <QRCodeForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

}
const mapDispatchToProps = () => {
    return {
        createQRCode: ( data ) => {
            return dAPI.post( '/admin/qr_codes', data );

        },
        updateQRCode: ( id, data ) => {
            return dAPI.patch( `/admin/qr_codes/${ id }`, data );

        },
    };
};

export default connect( null, mapDispatchToProps )( NewQRCodeModal );
